<template>
    <div class="dateTimePicker">
        <div v-if="showLabel" class="label">{{ labelName }}</div>
        <div class="content" :style="showLabel ?? { width: '100%' }">
            <el-date-picker v-model="dateValue" type="datetimerange" value-format="timestamp" range-separator="至"
                start-placeholder="开始时间" end-placeholder="结束时间" :picker-options="pickerOptions" @change="change($event)">
            </el-date-picker>
        </div>
    </div>
</template>

<script>
export default {
    name: "DateTimePicker",
    props: {
        showLabel: {
            type: Boolean,
            default: true
        },
        labelName: {
            type: String,
            default: '选择时间'
        },
    },
    components: {},
    data() {
        return {
            dateValue: [],
            //日期范围限制
            pickerOptions: {
                disabledDate(time) {
                    return time.getTime() > Date.now();
                },
            },
        }
    },
    methods: {
        change(value) {
            this.$emit('dateChange', value);
        }
    },
}
</script> 

<style lang="scss" scoped>
.dateTimePicker {
    @include setFlexBetween;

    .label {
        width: 60px;
    }

    .content {
        width: calc(100% - 70px);

        &>div {
            width: 100%;
        }
    }

    ::v-deep .el-range-input {
        font-size: 12px;
    }
}
</style>